export enum BatchLTLReplyAction {
  Drafted = 'drafted',
  Sent = 'sent',
  Copied = 'copied',
}

// What the Batch LTL panel's last reply covered, so Kit can describe the same outcome.
export type BatchLTLReplySummary = {
  // The email the shipments came from.
  emailId: number;
  action: BatchLTLReplyAction;
  inReplyCount: number;
  // Shipments the reply could not quote (no rates or missing info).
  remainingCount: number;
  // Every shipment shipped from one place, so Kit rows show only destinations.
  hasSharedOrigin: boolean;
};
